import React, { useState } from "react";
import {
  MDBNavbar,
  MDBContainer,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBNavbarItem,
  MDBCollapse,
  MDBBtn,
  MDBIcon,
  MDBNavbarNav,
  MDBTooltip,
} from "mdb-react-ui-kit";
import { useTranslation } from "./translations/useTranslation";
import { green, teal, red } from "@mui/material/colors";
import {
  Avatar,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Center,
  IconButton,
  Tooltip,
} from "@chakra-ui/react";
import FavoriteTwoToneIcon from "@mui/icons-material/FavoriteTwoTone";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import LogoutIcon from "@mui/icons-material/Logout";
import { ChatIcon } from "@chakra-ui/icons";
import GrassIcon from "@mui/icons-material/Grass";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import Modallogin from "./Modallogin";
import logo from "./Assets/logo.png";
import "./Navbar.css";

export default function Navbar({ auth, setAuth }) {
  const { t } = useTranslation();
  const [showNavNoTogglerSecond, setShowNavNoTogglerSecond] = useState(false);

  const [staticModal, setStaticModal] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");
  const toggleShow = () => setStaticModal(!staticModal);

  const handleLoginClick = () => {
    setActiveTab("tab1");
    toggleShow();
  };

  const handleRegisterClick = () => {
    setActiveTab("tab2");
    toggleShow();
  };

  function handleLogout() {
    localStorage.clear();
    window.location.href = "/";
    setAuth(false);
  }

  const name = localStorage.getItem("authname");
  const picture = localStorage.getItem("authpicture");

  return (
    <div>
      <MDBNavbar expand="lg" className="main-navbar">
        <MDBContainer fluid>
          {/* Brand */}
          <MDBNavbarBrand href="/" className="navbar-brand">
            <div className="brand-logo">
              <img src={logo} alt="" />
            </div>
          </MDBNavbarBrand>

          {/* Toggler */}
          <MDBNavbarToggler
            type="button"
            onClick={() =>
              setShowNavNoTogglerSecond(!showNavNoTogglerSecond)
            }
            className="navbar-toggler"
            aria-expanded={showNavNoTogglerSecond}
            aria-label="Toggle navigation"
          >
            <MDBIcon icon="bars" fas />
          </MDBNavbarToggler>

          {/* Collapsible Content */}
          <MDBCollapse navbar show={showNavNoTogglerSecond}>
            <MDBNavbarNav className="mr-auto mb-2 mb-lg-0">
              {/* Search Bar */}
              <div className="search-container">
                <form onSubmit={(e) => {
                  e.preventDefault();
                  const searchInput = e.target.querySelector('input').value;
                  if (searchInput.trim()) {
                    window.location.href = `/results?query=${encodeURIComponent(searchInput)}`;
                  }
                }}>
                  <input 
                    type="text" 
                    placeholder={t('searchPlaceholder') || "Search for seeds, tools, equipment..."} 
                    aria-label={t('search')}
                  />
                  <button type="submit" aria-label="Search">
                    <MDBIcon icon="search" />
                  </button>
                </form>
              </div>
           
            </MDBNavbarNav>

            {/* Authenticated Menu */}
            {auth && (
              <>
                <Tooltip label={t('chat') || "Chat"} placement="bottom" hasArrow>
                  <IconButton
                    as="a"
                    href="/chat"
                    variant="ghost"
                    colorScheme="green"
                    size="lg"
                    icon={<ChatIcon />}
                    className="avatar-btn"
                    aria-label={t('chat')}
                  />
                </Tooltip>
                <Tooltip label={t('socialFeed') || "Social Feed"} placement="bottom" hasArrow>
                  <IconButton
                    as="a"
                    href="/social"
                    variant="ghost"
                    colorScheme="blue"
                    size="lg"
                    icon={<MDBIcon fab icon="share-alt" />}
                    className="avatar-btn"
                    aria-label="Social Feed"
                  />
                </Tooltip>

                <Menu>
                  <Tooltip label={t('profile') || "Profile"} placement="bottom" hasArrow>
                    <MenuButton
                      as={Button}
                      rounded="full"
                      variant="link"
                      cursor="pointer"
                      px={3}
                      py={2}
                      className="avatar-btn"
                      aria-label="User menu"
                    >
                      <Avatar size="sm" src={picture} name={name} />
                    </MenuButton>
                  </Tooltip>
                  <MenuList alignItems="center" className="menu-list">
                    <br />
                    <Center>
                      <Avatar size="2xl" src={picture} name={name} />
                    </Center>
                    <br />
                    <Center>
                      <p className="user-name">{name}</p>
                    </Center>
                    <br />
                    <MenuDivider />
                    <a href="/profile">
                      <MenuItem>
                        <AccountBoxIcon sx={{ color: teal[500], marginRight: '10px' }} />
                        {t('viewEditProfile') || "View/Edit Profile"}
                      </MenuItem>
                    </a>
                    <a href="/myads">
                      <MenuItem>
                        <FavoriteTwoToneIcon sx={{ color: green[500], marginRight: '10px' }} />
                        {t('myProducts') || "My Products"}
                      </MenuItem>
                    </a>
                    <MenuItem onClick={handleLogout}>
                      <LogoutIcon sx={{ color: red[500], marginRight: '10px' }} />
                      {t('logout') || "Logout"}
                    </MenuItem>
                  </MenuList>
                </Menu>
              </>
            )}

            {/* Not Logged In - Show Profile Icon that redirects to login */}
            {!auth && (
              <Tooltip label={t('login') || "Login"} placement="bottom" hasArrow>
                <IconButton
                  onClick={handleLoginClick}
                  variant="ghost"
                  colorScheme="green"
                  size="lg"
                  icon={<AccountBoxIcon />}
                  className="avatar-btn"
                  aria-label={t('login')}
                />
              </Tooltip>
            )}
          </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>

      {/* Login/Register Modal */}
      <Modallogin
        setStaticModal={setStaticModal}
        toggleShow={toggleShow}
        staticModal={staticModal}
        activeTab={activeTab}
      />
    </div>
  );
}